/** Pipeline names used by reMap (DataExplorer). */
export const REMAP_PIPELINE_NAMES = {
  SCHEMA: 'remap_schema',
  ENTITY_LIST: 'remap_entity_list',
  ADJACENCY_COUNTS: 'remap_adjacency_counts',
  EXPAND_TO_LABEL: 'remap_expand_to_label',
  EXPLORATION: 'remap_exploration',
  SEARCH: 'remap_search',
} as const;

/** Match modes supported by pipeline `select_label` predicates (REV-2390). */
export const PIPELINE_SUPPORTED_FILTER_MODES = new Set([
  'contains',
  'notcontains',
  'equals',
  'notequals',
  'lt',
  'lte',
  'gt',
  'gte',
  'startswith',
  'endswith',
]);

/**
 * Relevance columns a `list_nodes` step can project when — and ONLY when — it
 * reads DIRECTLY off a `search` step's NodeSet.
 *
 * They are injected from the OpenSearch hit records the search handle carries,
 * not read from the graph, so any intervening op (`filter_nodes`, `traverse`,
 * `combine_handles`) produces a new NodeSet without them and the backend fails
 * the step loudly. See review_mcp `search_columns.py`.
 */
export const SEARCH_RELEVANCE_COLUMNS = [
  'search_score',
  'search_matched_property',
  'search_match_kind',
  'search_match_fragment',
] as const;

/** Step bindings of the `remap_search` pipeline (its `emit` list). */
export const REMAP_SEARCH_BINDINGS = {
  HITS: 'hits',
  /** The intermediate RowSet; only `ROWS` and `GRAPH` are emitted. */
  ROWS_RS: 'rows_rs',
  ROWS: 'rows',
  GRAPH: 'graph',
} as const;

/**
 * How many matches a reMap search asks for.
 *
 * The backend default (`OPENSEARCH_SEARCH_LIMIT`) is 10 — sized for an agent
 * reading results in a prompt, far too few for a canvas — so reMap always
 * sends an explicit limit.
 */
export const DEFAULT_REMAP_SEARCH_LIMIT = 50;

